import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UpdateInvestmentThemeInput } from 'shared';
import { toast } from 'sonner';

import { getInvestmentPortfolio, updateInvestmentTheme } from '../../lib/api/endpoints';

import { investmentThesisKeys } from './queries';

const portfolioKey = [...investmentThesisKeys.all, 'portfolio'] as const;

export function useInvestmentPortfolio() {
  return useQuery({
    queryKey: portfolioKey,
    queryFn: getInvestmentPortfolio,
  });
}

export function useUpdateInvestmentTheme() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateInvestmentThemeInput) => updateInvestmentTheme(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: portfolioKey });
      toast.success('Investment theme saved.');
    },
    onError: () => toast.error('Could not save the investment theme. Refresh and try again.'),
  });
}
